import { Injectable } from '@angular/core';
import { RequestService } from '@app/core/request/request.service';
import { Observable } from 'rxjs';
import { FormPerson } from '@app/core/interfaces/partij';

@Injectable()
export class InvolvedPartiesService {

    constructor(
        private request: RequestService,
    ) {}

    public getInvolvedParties(relatie_id: number, dossier_volgnummer: number): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer,
                relatie_id: relatie_id
            }
        };

        return this.request.post('schade-schademelden/opvragen/partijen', payload);
    }

    public setDriver(dossier_volgnummer: number, persoon: FormPerson): Observable<any> {
        const bestuurder = {...persoon};

        bestuurder['bestuurder_code'] = 'ANBE';

        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer
            },
            bestuurder: bestuurder
        };

        return this.request.post('schade-schademelden/vastleggen/bestuurder', payload);
    }

    public setWitness(relatie_id: number, dossier_volgnummer: number, persoon: FormPerson): Observable<any> {
        const payload = {
            dossier: {
                relatie_id: relatie_id,
                dossier_volgnummer: dossier_volgnummer
            },
            getuige: persoon
        };

        return this.request.post('schade-schademelden/vastleggen/getuige', payload);
    }

    public setContact(relatie_id: number, dossier_volgnummer: number, persoon: FormPerson): Observable<any> {
        const payload = {
            dossier: {
                relatie_id: relatie_id,
                dossier_volgnummer: dossier_volgnummer
            },
            contactpersoon: persoon
        };

        return this.request.post('schade-schademelden/vastleggen/contactpersoon', payload);
    }

    public setCoInsured(relatie_id: number, dossier_volgnummer: number, persoon: FormPerson): Observable<any> {
        const payload = {
            dossier: {
                relatie_id: relatie_id,
                dossier_volgnummer: dossier_volgnummer
            },
            medeverzekerde: persoon
        };

        return this.request.post('schade-melden/vastleggen/medeverzekerde', payload);
    }

    public setCounterParty(dossier_volgnummer: number, persoon: FormPerson, np_of_nnp_code: string): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer
            },
            tegenpartij: {
                aard_letsel_code: null,
                letsel_indicatie: null,
                natuurlijk_persoon: (np_of_nnp_code === 'NP') ? persoon : null,
                niet_natuurlijk_persoon: (np_of_nnp_code === 'NNP') ? persoon : null,
                np_of_nnp_code: np_of_nnp_code,
                polisnummer: null,
                verzekeringsmaatschappij_adres_relatie_id: null
            }
        };

        return this.request.post('schade-schademelden/vastleggen/tegenpartij', payload);
    }

    public setDriverCounterParty(dossier_volgnummer: number, persoon: FormPerson, tegenpartij_volgnummer: number): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer
            },
            tegenpartij: {
                tegenpartij_volgnummer: tegenpartij_volgnummer,
                afwijkende_bestuurder_tegenpartij: {
                    natuurlijk_persoon: persoon
                }
            }
        };

        return this.request.post('schade-schademelden/vastleggen/bestuurder-tegenpartij', payload);
    }
}
